module.exports = __webpack_public_path__ + "static/media/morten.e868aca3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/morten.jpg
// module id = 619
// module chunks = 0